import React, { Component } from 'react'
import { Row, Col, Icon, Divider, Button, Modal, DatePicker, Input, Table, Checkbox, message, Select, Typography } from 'antd'
import { connect } from 'react-redux'
import { getCookie } from '../../hook'
import moment from 'moment';

import './style.css';

// Actions
import { save_resignation, 
        get_resignation, 
        delete_resignation, 
        update_resignation_relieving_date,
        update_reason_of_resignation,
        approve_resignation,
        reject_resignation,
        update_checklist_value,
        get_users,
        update_resignation_last_date,
        get_departments } from './actions/resignation.action';

let timer,x;
const { confirm } = Modal;
const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';
const Option = Select.Option;
const { Paragraph } = Typography;

class Resignation extends Component {

    constructor( props ){

        super( props );

        this.state = {
            data: [],
            users_list:[],
            new_visible: false,
            current_user: 0,
            current_user_type: 0,
            date_of_relieving: '',
            last_working_day: '',
            reason_of_resignation: '',
            department_id: 0,
            open_tab: false,
            departments_list: [{ text: 'None', value: 'None' }]
        }

        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleCancel = this.handleCancel.bind( this );
        this.handleDelete = this.handleDelete.bind( this );
        this.handleReliveDateChange = this.handleReliveDateChange.bind( this );
        this.handleReasonChange = this.handleReasonChange.bind( this );
        this.handleApprove = this.handleApprove.bind( this );
        this.handleReject = this.handleReject.bind( this );
        this.handleChecked = this.handleChecked.bind( this );
        this.handleLastDateChange = this.handleLastDateChange.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleLastDateChange( resignation_id, dateString ){
        this.props.update_resignation_last_date( resignation_id, dateString );
    }

    handleChecked( checklist_id, e ){

        let value = 0;
        if( e.target.checked === true ){
            value = 1;
        }

        this.props.update_checklist_value( checklist_id, value )

    }

    handleApprove( user_id, resignation_id ){
        this.props.approve_resignation( user_id, resignation_id );
    }
    
    handleReject( user_id, resignation_id ){
        this.props.reject_resignation( user_id, resignation_id );
    }

    handleReasonChange( resignation_id, reason ){
        this.props.update_reason_of_resignation( resignation_id, reason );
    }

    handleReliveDateChange( resignation_id, dateString ){
        this.props.update_resignation_relieving_date( resignation_id, dateString );
    }

    handleDelete( user_id, id ){

        let self = this;

        confirm({
            title: 'Do you want to delete?',
            onOk() {
                self.props.delete_resignation( user_id, id );
            },
            onCancel() {
                // Nothing
            },
        });

        
    }

    handleCancel(){
        this.setState({ new_visible: false });
    }

    handleSubmit(){

        let user_id =  this.state.current_user;
        let self = this;
        let data = {
            user_id: user_id,
            date_of_relieving: this.state.date_of_relieving,
            last_working_day: this.state.last_working_day,
            reason_of_resignation: this.state.reason_of_resignation 
        }

        if( this.state.date_of_relieving !== '' && this.state.reason_of_resignation !== '' ){

            confirm({
                title: 'Do you want to request resignation?',
                onOk() {
                    self.props.save_resignation( data );
                    self.setState({ 
                        new_visible: false,
                        date_of_relieving: '',
                        reason_of_resignation: ''  
                    });
                },
                onCancel() {
                    // Nothing
                    self.setState({
                        date_of_relieving: '',
                        reason_of_resignation: ''  
                    });
                },
            });

        }

    }

    componentDidMount() {
        let res_id = "all";

        if( this.props.match.params.id ){
            res_id = this.props.match.params.id
        }

        let user = getCookie('dv_hrms_user').split(',');
        this.props.get_users();
        this.props.get_departments();
        this.props.get_resignation( user[6], res_id );

        this.setState({
            current_user: user[1],
            current_user_type: user[3],
            department_id: user[7]
        });

        if( res_id !== "all" ){
            this.setState({ open_tab: true });
        }

    }

    componentWillReceiveProps( nextProps ){

        let res_id = "all";

        if( this.props.match.params.id ){
            res_id = this.props.match.params.id
        }
        
        if( nextProps.resignation.length !== 0 ){

            if( nextProps.resignation.STATUS.CODE === "200" &&
                nextProps.resignation.STATUS.MESSAGE === "Successfully Saved" ){
                this.setState({ new_visible: false });
                let user = getCookie('dv_hrms_user').split(',');

                this.props.get_resignation( user[6], res_id );
            }

            if( nextProps.resignation.STATUS.CODE === "200" &&
                nextProps.resignation.STATUS.MESSAGE === "Successfully Listed Res Users" ){
                this.setState({
                    users_list: nextProps.resignation.OUTPUT.DATA
                });
            }

            if( nextProps.resignation.STATUS.CODE === "200" &&
                nextProps.resignation.STATUS.MESSAGE === "Successfully Listed Res Departments" ){
                this.setState({
                    departments_list: nextProps.resignation.OUTPUT.DATA
                });
            }

            if( nextProps.resignation.STATUS.CODE === "200" &&
                nextProps.resignation.STATUS.MESSAGE === "Successfully Listed Resignation" ){
                this.setState({
                    data: nextProps.resignation.OUTPUT.DATA
                });
            }

            if( nextProps.resignation.STATUS.CODE === "200" &&
                nextProps.resignation.STATUS.MESSAGE === "Successfully Update Resignation" ){
                let user = getCookie('dv_hrms_user').split(',');
                this.props.get_resignation( user[6], res_id );
            }

            if( nextProps.resignation.STATUS.CODE === "200" &&
                nextProps.resignation.STATUS.MESSAGE === "Successfully Deleted Resignation" ){
                let user = getCookie('dv_hrms_user').split(',');
                this.props.get_resignation( user[6], res_id );
            }

            if( nextProps.resignation.STATUS.CODE === '200' &&
                nextProps.resignation.STATUS.MESSAGE === 'Successfully Update Resignation' ){
                message.success( 'Successfully Updated!' );
            }

            if( nextProps.resignation.STATUS.CODE === "400" ){
                message.error( nextProps.resignation.STATUS.MESSAGE );
            }

        }

    }

    render() {

        const columns = [
            {
                title: 'Employee Name',
                dataIndex: 'full_name',
                key: 'full_name',
                width: '12%',
                ...this.getColumnSearchProps( 'full_name' )
            },
            {
                title: 'Department',
                dataIndex: 'department_name',
                key: 'department_name',
                width: '12%',
                filters: this.state.departments_list,
                onFilter: (value, record) => record.department_name.indexOf(value) === 0,
            },
            {
                title: 'Date Of Joining',
                dataIndex: 'date_of_joining',
                key: 'date_of_joining',
                width: '12%',
            },
            {
                title: 'Date Of Relieving',
                key: 'date_of_relieving',
                width: '12%',
                render: ( data ) => <span>
                    <DatePicker 
                        onChange={ ( date, dateString ) => this.handleReliveDateChange( data.resignation_id, dateString ) }
                        defaultValue={ moment( data.date_of_relieving, dateFormat)} />
                </span>
            },
            {
                title: 'Last Working Day',
                key: 'last_working_day',
                width: '12%',
                render: ( data ) => <span>
                    <DatePicker 
                        onChange={ ( date, dateString ) => this.handleLastDateChange( data.resignation_id, dateString ) }
                        defaultValue={ moment( data.last_working_day, dateFormat)} />
                </span>
            },
            {
                title: 'Reason Of Resignation',
                key: 'reason_of_resignation',
                render: ( data ) => <span>
                    <Paragraph editable={{ onChange: ( str ) => this.handleReasonChange(  data.resignation_id, str ) }}>{ data.reason_of_resignation }</Paragraph>
                </span>
            },{
                title: 'Actions',
                key: 'actions',
                render: ( data ) => <span>
                    
                    {
                        ( this.state.current_user_type === 'admin' || this.state.current_user_type === 'manager' ||
                        this.state.current_user_type === 'director') ? <Button
                        onClick={ () => this.handleApprove( this.state.current_user, data.resignation_id ) }
                        size="small" type={ (data.approve === '1') ? 'default': 'primary' } className="mrg_r_10">{ (data.approve === '1') ? 'Approved': 'Approve' }</Button> : ''
                    }
                    
                    {
                        ( this.state.current_user_type === 'admin' || this.state.current_user_type === 'manager' ||
                        this.state.current_user_type === 'director') ? <Button
                        onClick={ () => this.handleReject( this.state.current_user, data.resignation_id ) }
                        size="small" type={ (data.reject === '1') ? 'default': 'primary' } className="mrg_r_10">{ (data.reject === '1') ? 'Rejected': 'Reject' }</Button> : ''
                    }

                    <Button 
                        disabled={ ( data.approve === '1' && this.state.current_user_type !== 'admin' && this.state.current_user_type !== 'manager' &&
                        this.state.current_user_type !== 'director' ) ? true : false }
                        onClick={ () => this.handleDelete( data.user_id, data.resignation_id ) }
                        icon="delete" size="small" type="danger" />
                    
                </span>
            }
        ];

        const users_list = this.state.users_list.map( (item, k ) => <Option key={ item.user_id }>{ item.full_name }</Option> )

        return (


            <div className="resignation_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="user-delete" />
                            &nbsp; Employee Resignation 
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ ()=> this.setState({ new_visible: true }) }
                            className="fl_right" 
                            type="primary" >Resignation Request</Button>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Table columns={ columns } dataSource={ this.state.data } defaultExpandedRowKeys={ ( this.props.match.params.id ) ? [0] : '' }
                            expandedRowRender={ record => <div style={{ margin: 0 }} >
                            <Row>
                                <Col span={24}>
                                    <h2 className="mrg_b_20">Check List</h2>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>

                                    {

                                        ( record.checklist ) ? 
                                            record.checklist.map( (item, k ) => <div key={ k }>
                                                { Object.keys( item ).map( ( innerItem, i ) => <div key={ i } 
                                                    className="mrg_b_10"
                                                    style={{ 
                                                        clear: 'both',
                                                        overflow: 'hidden'
                                                    }}>
                                                    <h4>{ innerItem }</h4>
                                                    <div>
                                                        <ul className="checklist_view">
                                                            { item[ innerItem ].map( ( values, j ) =>
                                                                
                                                                <li key={ j }>
                                                                    <Checkbox
                                                                        disabled={ ( values.department_id === this.state.department_id || this.state.current_user_type === 'admin' ) ? false : true }
                                                                        onChange={ ( e ) => this.handleChecked( values.user_checklist_id, e ) }
                                                                        defaultChecked={ ( values.checked === '1' ) ? true : false }
                                                                        >{ values.check_list_name }</Checkbox>
                                                                </li>
                                                                
                                                            ) }
                                                        </ul>
                                                    </div>
                                                </div> ) }
                                            </div> ) : ''

                                    }

                                </Col>
                            </Row>

                        </div> } />
                    </Col>
                </Row>

                {/* New */}
                <Modal
                    title="New Resignation Request"
                    maskClosable={ false }
                    visible={ this.state.new_visible }
                    onOk={this.handleSubmit }
                    onCancel={ this.handleCancel }>
                    <Row>
                        <Col span={24}>
                                
                            { ( this.state.current_user_type === 'admin' ) ? <Row>
                                <Col span={24} className="mrg_b_15">
                                    <label>Select Employee</label>
                                    <Select
                                        showSearch
                                        style={{width: '100%'}}
                                        value={this.state.current_user}
                                        onChange={ (value) => this.setState({ current_user: value }) }
                                        filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }>
                                        { users_list }
                                    </Select>
                                </Col>
                            </Row> : ''  }

                            <Row>
                                <Col span={24} className="mrg_b_15">
                                    <label>Date of Relieving</label>
                                    <DatePicker 
                                        style={{ width: '100%' }}
                                        onChange={ ( date, dateString ) => 
                                        this.setState({ date_of_relieving: dateString }) } />
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24} className="mrg_b_15">
                                    <label>Last Working Day</label>
                                    <DatePicker 
                                        style={{ width: '100%' }}
                                        onChange={ ( date, dateString ) => 
                                        this.setState({ last_working_day: dateString }) } />
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24}>
                                    <label>Reason of Resignation</label>
                                    <TextArea rows={4} onChange={ ( e ) => 
                                        this.setState({ reason_of_resignation: e.target.value })} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal>
            </div>
        )
    }
}


function mapStateToProps( state ) {
    return {
        resignation: state.resignation
    }
}

export default connect( mapStateToProps, { 
    save_resignation,
    get_resignation,
    delete_resignation,
    update_resignation_relieving_date,
    update_reason_of_resignation,
    approve_resignation,
    reject_resignation,
    update_checklist_value,
    get_users,
    update_resignation_last_date,
    get_departments } )( Resignation );


// WEBPACK FOOTER //
// ./src/pages/resignation/index.js